import React /* , { useEffect, useState } */ from "react";
import { OpenFeatureProvider /*, initializeFeatureFlags */ } from "./ff";

export const FeatureFlagProvider = ({ children }) => {
  // const [isInitialized, setIsInitialized] = useState(false);

  return <OpenFeatureProvider>{children}</OpenFeatureProvider>;
};
